import React from 'react';
import './ServiceProduct.scss';
import TabChanger from "./TabChanger/TabChanger";
import MultiTable from "./MultiTable/MultiTable";

const ServiceProduct = ({initialData, setSendData, sendData}) => {

    return (

        <div className="main-tab-table">

            <div className="tab-changer-side">
                <TabChanger
                    initialData={initialData}
                    sendData={sendData}
                    setSendData={setSendData}
                />
            </div>

            <div className="multi-table-side">
                <MultiTable
                    sendData={sendData}
                    setSendData={setSendData}
                />
            </div>

        </div>

    );
}
export default ServiceProduct;
